import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

export const HeaderStyled = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h1 {
      color: ${commonColors.grey900};
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 140%;
      letter-spacing: 0.28px;
      text-transform: capitalize;
    }

    p {
      color: ${commonColors.grey700};
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0.09px;
    }
  }

  > a {
    text-decoration: none;
    button {
      height: 38px;
      width: fit-content;
      background: ${commonColors.white};

      > svg {
        path {
          fill: ${commonColors.blue800};
        }
      }
    }
  }
`;
